<template>
    <PublicPageLayout heading="§public.login_heading">
        <CoreStringInput
            v-model="email"
            :fullWidth="true"
            placeholder="§ui.placeholder_login_email"
            class="mb-4"
        />

        <CorePasswordInput
            v-model="password"
            :fullWidth="true"
            class="mb-3"
        />

        <div class="public_pages__forgot-password mb-12">
            <CoreLinkPrimary
                text="§ui_button.forgot_password"
                iconName="arrow-right"
                :to="{ path: '/password/reset_request' }"
            />
        </div>

        <div class="login__checkbox mb-16">
            <CoreCheckbox
                v-model="remember"
                name="remember_me"
                label="§ui_button.remember_me"
            />
        </div>

        <div class="flex">
            <CoreButton
                @click="handleSubmit"
                label="§ui_button.sign_in"
                icon="pi-arrow-up-right"
                :loading="authStore.loading"
                :disabled="authStore.loading"
            />
        </div>
    </PublicPageLayout>
</template>

<script>
import { getUserBrowserPreferredLocale } from '@/helpers/mixins'
import PublicPageLayout from './components/PublicPageLayout.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CorePasswordInput from '@/components/core/CorePasswordInput.vue'
import CoreLinkPrimary from '@/components/core/CoreLinkPrimary.vue'
import CoreCheckbox from '@/components/core/CoreCheckbox.vue'
import { useAuthStore } from '@/stores/auth'

export default {
    name: 'Login',

    components: {
        PublicPageLayout,
        CoreButton,
        CoreStringInput,
        CorePasswordInput,
        CoreLinkPrimary,
        CoreCheckbox,
    },

    mixins: [getUserBrowserPreferredLocale],

    data() {
        return {
            email: '',
            password: '',
            remember: false,
            waiting: false,
        }
    },

    created() {
        this.authStore = useAuthStore()
    },

    methods: {
        async handleSubmit() {
            try {
                if (this.waiting) return
                this.waiting = true

                await this.authStore.login({
                    email: this.email,
                    password: this.password,
                    remember: this.remember,
                })
            } catch (error) {
                this.waiting = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'An unexpected error occurred',
                    life: 2000,
                })
            } finally {
                this.waiting = false
            }
        },
    },
}
</script>
